<template>
    <div class="page">
        <div class="page__hd" v-if="main.name">
            <h3 class="page__title">上{{ main.periodType == 0 ? '周' : '月' }}{{ main.name }}</h3>
            <p class="page__desc">{{dateFormat(main.startDate, 'yyyy-MM-dd') }} ~ {{
                    dateFormat(main.endDate, 'yyyy-MM-dd') }}</p>
        </div>
        <div class="page__bd">
            <div class="list-container" v-if="items.length">
                <div class="list-fixed">
                    <p class="list-box-col__title">{{ fixedProperty.name }}</p>
                    <p class="list-box-col__content" v-for="(item, index) in items" :key="index">{{
                        item[fixedProperty.field] }}</p>
                </div>
                <div class="list-scroll">
                    <div class="list-scroll-wrap">
                        <div class="list-box-col" v-for="(property, i) in properties" :key="property.field"
                            :class="{ 'list-box-col-odd': i % 2 == 0 }">
                            <p class="list-box-col__title">{{ property.name }}</p>
                            <p class="list-box-col__content" v-for="(item, index) in items" :key="index">{{
                                item[property.field] }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="box box-warn weui-flex__center">
                <p class="text-muted">没有数据</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            main: {},
            items: [],
            fixedProperty: {},
            properties: []
        };
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.loadData(to.query);
        });
    },
    methods: {
        loadData(params) {
            var me = this
            me.$loading({
                url: "/api/stat/subscribe/data",
                params
            }).then(function (res) {
                if (res.success) {
                    if (res.data) {
                        me.main = res.data.main
                        me.items = res.data.items
                        me.fixedProperty = res.data.properties[0]
                        me.properties = res.data.properties.slice(1);
                    }
                    me.resp = res.data
                } else {
                    me.$router.push({
                        name: "Error",
                        params: res
                    });
                }
            });
        }
    }
};
</script>

<style scoped>
.page__hd {
  padding: 20px;
}

.page__title {
  text-align: left;
  font-size: 20px;
  font-weight: 400;
}

.page__desc {
  margin-top: 4px;
  color: var(--weui-FG-1);
  text-align: left;
  font-size: 14px;
}

.list-container {
    text-align: center;
    line-height: 40px;
    background: var(--weui-BG);
    display: flex;
    border-color: var(--weui-FG-3);
    border-width: 1px 0 0 0;
    border-style: solid;
}

.list-fixed {
    border-right: 1px solid var(--weui-FG-3);
    min-width: fit-content;
    max-width: 300px;
}

.list-scroll {
    flex-grow: 1;
    overflow-x: auto;
}

.list-scroll-wrap {
    display: flex;
}

.list-box-col {
    display: flex;
    flex-direction: column;
    border-right: 1px solid var(--weui-FG-3);
    min-width: fit-content;
    max-width: 300px;
}

.list-box-col:active {
    background: #e0e0e0;
}

.list-box-col-odd {
    background: var(--weui-BG-1);
}

.list-box-col__title {
    font-weight: bold;
    padding: 0 4px;
    border-bottom: 1px solid var(--weui-FG-3);
    min-width: fit-content;
    max-width: 300px;
}

.list-box-col__content {
    font-size: small;
    color: var(--weui-FG-0);
    padding: 0 4px;
    border-bottom: 1px solid var(--weui-FG-3);
    flex: 1;
    min-width: fit-content;
    max-width: 300px;
}
</style>